// export const wechatAppId = process.env.NODE_ENV==='development'?'wx0fc3fae0228c9ab3':'wxb41532ec5bb06e9f';
// export const host = process.env.NODE_ENV==='development'?'http://blinder-dev.hui51.cn': 'http://blinder.hui51.cn';
export const wechatAppId = 'xxx';
export const host = 'http://chess.zhisai.net';
export const apiHost = `${host}/api`;

// export const wsApi = `localhost:4000/`;

export const graphqlApi = `http://chess.zhisai.net/graphql`;
export const wsApi = `chess.zhisai.net/`;

// export const graphqlApi = `http://localhost:4000/graphql`;
// export const wsApi = 'localhost:4000'

export const uploadUrl = `http://localhost:10072/api/files`;
export const imgUrl = `http://localhost:10072/api/files/`;

export const debugInfo = (...args)=>{
  if(process.env.NODE_ENV==='development' || window.isDebug) {
    console.log(`[DEBUG]`,...args);
  }
}


// WEBPACK FOOTER //
// ./src/Config.js